import { yupResolver } from '@hookform/resolvers'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useGetBankCodeListingLazyQuery } from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'

export interface IUOMForm {
  EFTBankCodeID: string
  EFTCorporateID: string
  EFTCompanyID: string
}

export const CompanyEFTDialog = (props: any) => {
  const { open, setOpen, setErrDialog, setOpenExitConf, setErrMessage } = props
  const DialogSchema = yup.object().shape({
    EFTCorporateID: CommonYupValidation.requireField(SystemMsgs.code()),
    EFTCompanyID: CommonYupValidation.requireField(SystemMsgs.name()),
  })
  const [formMode, setFormMode] = useState('')

  const {
    handleSubmit,
    register,
    errors,
    control,
    reset,
    watch,
    formState: { isDirty },
  } = useForm<IUOMForm>({
    // defaultValues: {
    //   EFTCorporateID: formMode === 'add' ? '' : menu?.obj?.EFTCorporateID,
    //   EFTCompanyID: formMode === 'add' ? '' : menu?.obj?.EFTCompanyID,
    // },
    mode: 'all',
    resolver: yupResolver(DialogSchema),
  })
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()

  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: menu?.obj,
      formMode: formMode,
    })

  const [
    loadData,
    {
      data: { getBankCodeListing } = { getBankCodeListing: {} },
      loading: bankCodeLoading,
    },
  ] = useGetBankCodeListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  useEffect(() => {
    loadData()
  }, [])

  return (
    <CommonDialog
      fullWidth={true}
      open={open}
      onClose={() => {
        if (hasChanges() === true) {
          setOpenExitConf(true)
        } else {
          setOpen(false)
          reset()
        }
      }}
      sections={{
        header: {
          dynamic: (
            <div className="">
              <div className="dialog-dynamic-content">
                <div className="session">
                  <div className="flex session">
                    <div
                      className="dialog-title c-orange"
                      style={{ fontSize: '12px', fontWeight: 'bold' }}
                    >
                      Company EFT
                    </div>
                  </div>
                </div>
              </div>
              <div className="infoline-content">
                <div className="xsTitle">{menu?.obj?.Code}&nbsp; </div>
                <div className="flex-space"></div>
                <div className="xsTitle rightText">New </div>
              </div>
            </div>
          ),
        },
        body: () => (
          <div className="content-container">
            <Controller
              render={({ value, onChange }) => {
                return (
                  <Autocomplete
                    options={getBankCodeListing?.Data?.map(e => {
                      return {
                        ID: e?.EFTBankCodeID,
                        Code: e?.Code,
                        Name: e?.Name,
                      }
                    })}
                    getOptionLabel={option => `${option?.Name}`}
                    fullWidth
                    style={{
                      paddingRight: '0px',
                    }}
                    value={value}
                    onChange={(value, newValue: any) => {
                      onChange(newValue)
                    }}
                    renderInput={params => {
                      return (
                        <TextField
                          {...params}
                          style={{ width: '100%' }}
                          margin="dense"
                          label="EFT Bank Code"
                        />
                      )
                    }}
                  />
                )
              }}
              name="EFTBankCodeID"
              //   defaultValue={{
              //     ID: isEdit
              //       ? menu?.obj?.EFTBankCodeID ?? menu?.obj?.EFTBankCodeName?.EFTBankCodeID
              //       : '',
              //     Name: isEdit ? menu?.obj?.EFTBankCodeName?.Name : '',
              //   }}
              control={control}
            />

            <Controller
              as={TextField}
              label="EFT Corporate ID"
              required
              name="EFTCorporateID"
              autoFocus
              ref={register}
              control={control}
              //   helperText={
              //     duplicateCode() === true
              //       ? 'Code already existed'
              //       : errors?.EFTBankCode?.message
              //   }
              //   error={duplicateCode() || errors?.EFTBankCode ? true : false}
              autoComplete="off"
            />
            <Controller
              as={TextField}
              label="EFT Company ID"
              required
              name="EFTCompanyID"
              ref={register}
              control={control}
              //   helperText={
              //     duplicateName() === true
              //       ? 'Name already existed'
              //       : errors?.Name?.message
              //   }
              //   error={duplicateName() || errors?.Name ? true : false}
              autoComplete="off"
            />
          </div>
        ),
        footer: {
          actions: [
            {
              displayText: 'Cancel',
              props: {
                onClick: () => {
                  if (hasChanges() === true) {
                    setOpenExitConf(true)
                  } else {
                    setOpen(false)
                    reset()
                  }
                },
                variant: 'contained',
                color: 'primary',
              },
            },
            {
              displayText: 'Save',
              props: {
                onClick: () => {},
                variant: 'contained',
                color: 'primary',
                form: 'createUOM-form',
                type: 'submit',
              },
            },
          ],
        },
      }}
    />
  )
}
